import { render, staticRenderFns } from "./gift-picker.vue?vue&type=template&id=23ec30c0&scoped=true"
import script from "./gift-picker.vue?vue&type=script&lang=js"
export * from "./gift-picker.vue?vue&type=script&lang=js"
import style0 from "./gift-picker.vue?vue&type=style&index=0&id=23ec30c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec30c0",
  null
  
)

export default component.exports